exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rounded-top-lg[data-v-20197ced]{border-top-left-radius:1.5rem;border-top-right-radius:1.5rem}.font-size-change-btn[data-v-20197ced]{width:48px;height:48px;border-radius:50%;display:flex;align-items:center;justify-content:center;color:#000;text-decoration:none}.modal-backdrop[data-v-20197ced]{background-color:rgba(0,0,0,.35);height:100%}", ""]);

// exports
